/**
 * SEAM → Analytics fixtures. The backend exposes no analytics rollup endpoint
 * yet, so the Intelligence dashboard is populated with representative figures
 * (deltas, sparkline trends, a 14-day series). Swap for a real aggregate query
 * when one lands — the page consumes only these shapes.
 */

export interface AnalyticsKpi {
  value: string;
  delta: { value: string; tone: 'up' | 'down' | 'neutral' };
  trend: number[];
}

export const ANALYTICS_KPIS: {
  callsHandled: AnalyticsKpi;
  bookings: AnalyticsKpi;
  aht: AnalyticsKpi;
  languages: AnalyticsKpi;
} = {
  callsHandled: {
    value: '1,284',
    delta: { value: '+12%', tone: 'up' },
    trend: [62, 70, 66, 78, 84, 80, 92, 88, 96, 101, 98, 110, 116, 124],
  },
  bookings: {
    value: '213',
    delta: { value: '+8%', tone: 'up' },
    trend: [9, 11, 10, 12, 14, 13, 15, 16, 15, 18, 17, 19, 21, 22],
  },
  aht: {
    value: '1:38',
    delta: { value: '−9s', tone: 'down' },
    trend: [112, 110, 108, 109, 105, 104, 103, 101, 100, 99, 98, 97, 99, 98],
  },
  languages: {
    value: '9',
    delta: { value: '+1', tone: 'up' },
    trend: [6, 6, 7, 7, 7, 8, 8, 8, 8, 9, 9, 9, 9, 9],
  },
};

export const ANALYTICS_TREND = {
  xLabels: ['06', '08', '10', '12', '14', '16', '19'],
  calls: [62, 70, 66, 84, 92, 101, 124],
  bookings: [9, 11, 10, 14, 16, 18, 22],
};
